import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { environment } from '../environments/environment';
import { FormsModule } from '@angular/forms';
import { DashboardComponent } from './game/dashboard/dashboard.component';
import { Dnd5eSheetComponent } from './game/dnd5e-sheet/dnd5e-sheet.component';
import { HomeComponent } from './public/home/home.component';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { LogoutComponent } from './components/logout/logout.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DocumentLoadService } from './services/document-load.service'
import 'rxjs/add/operator/toPromise';
import { 
  MatButtonModule, 
  MatCheckboxModule, 
  MatListModule, 
  MatCardModule,
  MatSidenavModule
} from '@angular/material';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatButtonModule, MatCheckboxModule, MatListModule, MatCardModule, MatSidenavModule,
    AngularFireModule.initializeApp(environment.firebase, 'beyond-tabletop'), // imports firebase/app needed for everything
    AngularFirestoreModule.enablePersistence(), // imports firebase/firestore, only needed for database features
    AngularFireAuthModule, // imports firebase/auth, only needed for auth features
    FormsModule, AppRoutingModule,
  ],
  declarations: [
    AppComponent,
    DashboardComponent,
    HomeComponent,
    LogoutComponent,
    Dnd5eSheetComponent
  ],
  providers: [ DocumentLoadService ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/traev/Sites/btt/src/app/app.module.ts